import Rating from '@mui/material/Rating'
import Box from '@mui/material/Box'
import { Button, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material'
import styled from 'styled-components'
import NotesIcon from '@mui/icons-material/Notes'
//@ts-ignore
import Logo from 'src/assets/small-logo.png'
//@ts-ignore
import FullLogo from 'src/assets/sauterundheld_logo.png'

const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;
`

const StyledQuestionDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
    max-width: 800px;
    min-height: 300px;
`

const StyledActionButtonsDiv = styled.div`
    display: flex;
    width: 80%;
    justify-content: space-between;
`

const StyledStepper = styled(Stepper)`
    min-width: 1000px;
`

const StyledDiv = styled.div`
    display: flex;
    gap: 10px;
`

const StyledButton = styled(Button)<{ isHidden: boolean; fontColor?: string }>`
    color: ${(props) => props.fontColor};
    display: ${(props) => (props.isHidden ? 'none' : 'block')};
`

const StyledTextArea = styled(TextField)`
    min-width: 500px;
`

const StyledThanksDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
`

const StyledFullLogo = styled.img`
    width: 275px;
    height: 70px;
`

interface FeedbackFormProps {
    steps: Array<string>
    currentStep: number
    rating: number
    feedbackText: string
    onChangeFeedbackText: (value: string) => void
    onChangeRating: (value: number) => void
    onNextStep: () => void
    onPreviousStep: () => void
    onFinishFeedback: () => void
}
export function FeedbackForm({
    steps,
    currentStep,
    rating,
    feedbackText,
    onChangeFeedbackText,
    onChangeRating,
    onNextStep,
    onPreviousStep,
    onFinishFeedback,
}: FeedbackFormProps) {
    const hasNextStep = currentStep < steps.length + 1 && rating !== 0
    const isLastStep = currentStep === steps.length + 2
    const isAnnotationStep = currentStep === steps.length + 1

    return (
        <StyledBox>
            <StyledQuestionDiv>
                {currentStep === steps.length + 1 ? (
                    <StyledTextArea
                        label="Hier ist Platz für dein Feedback"
                        placeholder=""
                        value={feedbackText}
                        onChange={(e) => onChangeFeedbackText(e.target.value)}
                        multiline
                        minRows={6}
                    />
                ) : isLastStep ? (
                    <StyledThanksDiv>
                        <div>
                            <Typography variant="h5" paddingBottom="10px" textAlign="center">
                                Vielen Dank! Was du denkst, ist uns wichtig.
                            </Typography>
                            <Typography variant="body2" textAlign="center">
                                {' '}
                                Wir wissen es sehr zu schätzen, dass Du dir die Zeit genommen hast.
                            </Typography>
                            <Typography variant="body2" textAlign="center">
                                Mit Deinem Feedback entwickeln wir uns gemeinsam weiter. Dein Sauter + Held Team.
                            </Typography>
                        </div>
                        <StyledFullLogo src={FullLogo} />
                    </StyledThanksDiv>
                ) : (
                    <>
                        <Typography variant="h6" color="GrayText">
                            {steps[currentStep - 1]}
                        </Typography>
                        <Rating sx={{ fontSize: '3rem' }} value={rating} onChange={(event, newValue) => onChangeRating(Number(newValue))} />
                    </>
                )}
            </StyledQuestionDiv>
            <StyledStepper activeStep={currentStep - 1} alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel StepIconProps={{ style: { color: 'rgb(3, 130, 194)' } }}>Frage {index + 1}</StepLabel>
                    </Step>
                ))}
                <Step>
                    <StepLabel
                        icon={
                            <NotesIcon
                                color={isAnnotationStep ? 'action' : currentStep > steps.length + 1 ? 'primary' : 'disabled'}
                                style={{ color: 'rgb(3, 130, 194)' }}
                            />
                        }>
                        Anmerkungen
                    </StepLabel>
                </Step>

                <Step>
                    <StepLabel icon={<img src={Logo}></img>}>Danke</StepLabel>
                </Step>
            </StyledStepper>
            <StyledActionButtonsDiv>
                <StyledButton isHidden={isLastStep} color="secondary" disabled={currentStep === 1} onClick={onPreviousStep}>
                    Zurück
                </StyledButton>
                <StyledDiv>
                    <StyledButton isHidden={isLastStep} color="secondary" disabled={!hasNextStep} onClick={onNextStep}>
                        Nächste Frage
                    </StyledButton>
                    <StyledButton
                        variant="contained"
                        fontColor="white"
                        color="success"
                        isHidden={!isAnnotationStep}
                        onClick={onFinishFeedback}>
                        Abschließen
                    </StyledButton>
                </StyledDiv>
            </StyledActionButtonsDiv>
        </StyledBox>
    )
}
